// src/pages/Home.js
import React from "react";
import logo from "../assets/images/logo.webp";
// import "./index.css";

function Home() {
  return (
    <div className="home-container">
      <img src={logo} alt="Logo" className="home-logo" />
      <div className="home-content">
        <h1>iOPEX Commerce Media</h1>
        <h1>Partnership Opportunity</h1>
      </div>
    </div>
  );
}

export default Home;
